import { Label, Text, TextField } from '@fluentui/react';
import { textProp } from 'global/Application';
import { IStringValue } from 'model/FlexibleAttributeModel';
import { useEffect, useState } from 'react';

interface IProps {
    [key: string]: any;
    label?: string;
    disabled?: boolean;
    fieldValueOnChange?: (event: any, value: IStringValue) => void;
    defaultFieldValue?: IStringValue;
}

const TextFieldControl = (props: IProps) => {
    const [value, setValue] = useState<string>(props.defaultFieldValue ? props.defaultFieldValue.value : props.defaultValue);

    useEffect(() => {
        setValue(props.defaultFieldValue ? props.defaultFieldValue.value : props.defaultValue)
    }, [props.defaultFieldValue, props.defaultValue]);

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{props?.defaultFieldValue?.value ?? props?.defaultValue ?? '---'}</Text>
        </div>;

    return <TextField
        label={props.label}
        // onChange={props.fieldValueOnChange ? fieldValueOnChange : handleChange}
        onChange={(event, newValue) => { setValue(newValue ?? '') }}
        value={value}
        disabled={props.disabled}
        maxLength={4000}
        onBlur={(event) => {
            const newValue: IStringValue = {
                type: 'string',
                value: value!
            }
            props.fieldValueOnChange?.(event, newValue);
        }}
        {...props.other}
    />
}

export default TextFieldControl